// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewGroupSection.test.tsx
//
// Over the artwork while one group is open (warhol spec dave.savostyanov/0090):
// back to every group, the previous or next finding, which walks this group's
// pins and then the next group's, and the group's name and size.
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { usePinGroupName } from "./AskV2ReviewGroupSection";
import { type PinGroup } from "./pinGroups";

const PILL =
  "flex h-7 items-center gap-1.5 rounded-md border border-puntt-neutral-gray-5 bg-base-white px-2.5 text-[13px] font-medium shadow-sm hover:bg-puntt-neutral-gray-2";

export function AskV2ReviewPinGroupBar({
  group,
  onBack,
  onStep,
}: {
  group: PinGroup;
  onBack: () => void;
  onStep: (direction: 1 | -1) => void;
}) {
  const { t } = useTranslation("ui");
  const nameOf = usePinGroupName();
  return (
    // why z-40: the viewer's spotlight scrim (z-[15]), pins (z-20) and loading
    // veil (z-30) share this stacking context and would dim or cover the bar.
    <div
      className="pointer-events-none absolute inset-x-4 top-3 z-40 flex items-center gap-1.5"
      data-testid="pin-zone-bar"
    >
      <button
        type="button"
        className={`${PILL} pointer-events-auto`}
        data-testid="pin-zone-back"
        onClick={onBack}
      >
        <CaretLeft size={12} aria-hidden="true" />
        {t("askV2.review.pinGroups.back")}
      </button>
      <button
        type="button"
        className={`${PILL} pointer-events-auto`}
        data-testid="pin-zone-prev"
        aria-label={t("askV2.review.pinGroups.prev")}
        onClick={() => onStep(-1)}
      >
        <CaretLeft size={12} aria-hidden="true" />
      </button>
      <button
        type="button"
        className={`${PILL} pointer-events-auto`}
        data-testid="pin-zone-next"
        aria-label={t("askV2.review.pinGroups.next")}
        onClick={() => onStep(1)}
      >
        <CaretRight size={12} aria-hidden="true" />
      </button>
      {/* why after the steps: the name changes width group to group, and the steps must stay under the cursor. */}
      <span
        className={`${PILL} pointer-events-auto min-w-0 font-normal text-puntt-neutral-gray-11 hover:bg-base-white`}
        data-testid="pin-zone-name"
      >
        <span className="truncate">
          {t("askV2.review.pinGroups.zone", {
            name: nameOf(group),
            count: group.members.length,
          })}
        </span>
      </span>
    </div>
  );
}
